import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Inject,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Optional,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { SnackBarService } from 'src/app/services/snackBar/snack-bar.service';

declare var MediaRecorder: any;

@Component({
  selector: 'app-photo-capture',
  templateUrl: './photo-capture.component.html',
  styleUrls: ['./photo-capture.component.scss'],
})
export class PhotoCaptureComponent
  implements OnDestroy, AfterViewInit, OnInit, OnChanges
{
  @ViewChild('videoElement') videoElement!: any;
  @ViewChild('capturedPhotoElement') capturedPhotoElement!: ElementRef;
  capturedPhoto: any = null;
  stream: any = null;
  mode: 'photo' | 'video' = 'photo';
  isRecording = false;
  recordedChunks: Blob[] = [];
  mediaRecorderObject: any;
  recordTime: number = 0;

  preview = false;

  front = true;

  selectedFiles: { file: File; base64: string; type: 'photo' | 'video' }[] = [];

  sliderIndex: number = 0;

  @Input() multipleSelectionEnabled: boolean = false;

  constructor(
    @Optional() public dialogRef: MatDialogRef<PhotoCaptureComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
    private snackBarService: SnackBarService,
    private cdr: ChangeDetectorRef,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {
    this.preview = false;
    if (
      this.dialogData &&
      typeof this.dialogData.multipleSelectionEnabled === 'boolean'
    ) {
      this.multipleSelectionEnabled = this.dialogData.multipleSelectionEnabled;
    }
    this.initializeCamera();
  }

  ngAfterViewInit() {}

  ngOnDestroy() {
    this.pararVideo();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes['multipleSelectionEnabled'] &&
      !changes['multipleSelectionEnabled'].firstChange
    ) {
      // Si cambiamos de múltiple a simple, limpiamos los archivos seleccionados
      if (!this.multipleSelectionEnabled && this.selectedFiles.length > 1) {
        // Dejamos solo el primero
        this.selectedFiles = this.selectedFiles.slice(0, 1);
        this.sliderIndex = 0;
        this.updateSliderView();
      }
    }
  }

  showSnackBarError(mensaje: string) {
    this.snackBarService.openSnackBarError(mensaje, 10000);
  }

  async convertToWebM(base64String: any) {
    const byteCharacters = atob(base64String);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);

    // Crear el objeto Blob
    const blob = new Blob([byteArray], { type: 'video/webm' });

    console.log(blob);
  }

  onFileSelected(event: any) {
    const files: FileList = event.target.files;
    if (files && files.length > 0) {
      if (!this.multipleSelectionEnabled) {
        this.selectedFiles = [];
      }
      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        const extension = file?.name?.split('.')?.pop()?.toLowerCase();
        const reader = new FileReader();
        let blob: any = null;
        if (this.isPhoto(extension)) {
          blob = new Blob([file], { type: 'image/jpeg' });
        } else if (this.isVideo(extension)) {
          blob = new Blob([file], { type: 'video/webm' });
        } else {
          continue;
        }
        reader.onload = ((fileReader) => {
          return (e: any) => {
            const base64String = e.target.result;
            this.selectedFiles.push({
              file,
              base64: base64String,
              type: this.isPhoto(extension) ? 'photo' : 'video',
            });
            // Mostrar previsualización solo del primero
            if (
              !this.multipleSelectionEnabled ||
              this.selectedFiles.length === 1
            ) {
              this.sliderIndex = 0;
              this.capturedPhoto = base64String;
              this.mode = this.isPhoto(extension) ? 'photo' : 'video';
              this.preview = true;
            }
          };
        })(reader);
        reader.readAsDataURL(blob);
      }
    }
  }

  isPhoto(extension: any): boolean {
    if (
      ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'tif', 'tiff', 'webp'].includes(
        extension
      )
    ) {
      return true;
    }
    return false;
  }

  isVideo(extension: any): boolean {
    if (
      ['mp4', 'mov', 'avi', 'wmv', 'mkv', 'flv', 'webm'].includes(extension)
    ) {
      return true;
    }
    return false;
  }

  async initializeCamera() {
    try {
      const constraints: MediaStreamConstraints = {
        audio: true,
        video: {
          width: { max: 1280 },
          height: { max: 720 },
          frameRate: { ideal: 30 },
          facingMode: this.front ? 'user' : 'environment',
        },
      };
      this.stream = await navigator.mediaDevices.getUserMedia(constraints);
      console.log(this.stream);
      this.videoElement.nativeElement.srcObject = this.stream;
    } catch (error: any) {
      this.showSnackBarError('Error al abrir la camara');
    }
  }

  async switchCamera() {
    try {
      this.front = !this.front;

      const constraints: MediaStreamConstraints = {
        video: {
          width: { max: 1280 },
          height: { max: 720 },
          frameRate: { ideal: 40 },
          facingMode: this.front ? 'user' : 'environment',
        },
        audio: true,
      };

      console.log(this.stream);

      // Detiene la cámara actual
      this.stream
        .getTracks()
        .forEach((track: MediaStreamTrack) => track.stop());

      // Inicia la siguiente cámara
      setTimeout(async () => {
        this.stream = await navigator.mediaDevices.getUserMedia(constraints);
        this.videoElement.nativeElement.srcObject = this.stream;
      }, 500);
    } catch (error: any) {
      this.showSnackBarError(error);
    }
  }

  toggleMode() {
    if (this.mode === 'photo') {
      this.mode = 'video';
    } else {
      this.mode = 'photo';
    }
  }

  startRecording() {
    if (this.stream) {
      const intervalId = setInterval(() => {
        this.recordTime = this.recordTime + 1;
        if (this.recordTime === 95) {
          this.stopRecording();
        }
      }, 1000);
      this.recordedChunks = [];
      let mimeType = 'video/webm';

      console.log(navigator.userAgent);

      if (
        navigator.userAgent.indexOf('Safari') !== -1 &&
        (navigator.userAgent.indexOf('Chrome') === -1 ||
          navigator.userAgent.indexOf('Mozilla') === -1)
      ) {
        mimeType = 'video/mp4';
      }

      this.mediaRecorderObject = new MediaRecorder(this.stream, {
        mimeType: mimeType,
        audioBitsPerSecond: 8000,
        videoBitsPerSecond: 400000,
        video: {
          frameRate: 30,
          width: {
            max: 1920,
          },
          height: {
            max: 1080,
          },
        },
      });

      this.mediaRecorderObject.ondataavailable = (event: any) => {
        this.recordedChunks.push(event.data);
      };

      this.mediaRecorderObject.onstop = () => {
        clearInterval(intervalId);
        const blob = new Blob(this.recordedChunks, { type: mimeType });

        // const videoSizeMB = this.calculateVideoSize();
        // console.log('Tamaño del video:', videoSizeMB.toFixed(2), 'MB');

        // if (videoSizeMB > 10) {
        //   this.showSnackBarError(
        //     'No se puede adjuntar un archivo mayor a 10 MB'
        //   );
        //   this.recordTime = 0;
        //   return;
        // }

        const reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onloadend = () => {
          const base64data = reader.result;
          this.capturedPhoto = base64data as string;
          this.preview = true;
          this.recordTime = 0;
          this.cdr.detectChanges();
        };
      };

      this.mediaRecorderObject.start();
      this.isRecording = true;
    }
  }

  calculateVideoSize(): number {
    // Calcular el tamaño total del video en MB
    const totalSizeBytes = this.recordedChunks.reduce(
      (acc, chunk) => acc + chunk.size,
      0
    );
    return totalSizeBytes / (1024 * 1024);
  }

  segundosAHorasMinutosSegundos(segundos: number) {
    const horas = Math.floor(segundos / 3600);
    const minutos = Math.floor((segundos % 3600) / 60);
    const segundosRestantes = segundos % 60;

    // Agregar ceros delante si es necesario para mantener el formato "xx:xx:xx"
    const formatoHoras = horas < 10 ? '0' + horas : horas;
    const formatoMinutos = minutos < 10 ? '0' + minutos : minutos;
    const formatoSegundos =
      segundosRestantes < 10 ? '0' + segundosRestantes : segundosRestantes;

    return formatoHoras + ':' + formatoMinutos + ':' + formatoSegundos;
  }

  stopRecording() {
    if (this.stream) {
      this.mediaRecorderObject.stop();
      this.isRecording = false;
    }
  }

  capturePhoto() {
    const canvas = document.createElement('canvas');
    canvas.width = this.videoElement.nativeElement.videoWidth;
    canvas.height = this.videoElement.nativeElement.videoHeight;

    const context = canvas.getContext('2d');
    context?.drawImage(
      this.videoElement.nativeElement,
      0,
      0,
      canvas.width,
      canvas.height
    );

    this.capturedPhoto = canvas.toDataURL('image/png');
    console.log(this.capturedPhoto);
    this.preview = true;
  }

  startVideo() {}

  repeatPhoto() {
    this.capturedPhoto = null;
    this.selectedFiles = [];
    this.preview = false;
    this.sliderIndex = 0;
  }

  finalizar() {
    this.pararVideo();
    
    // Si hay una foto capturada pero no está en selectedFiles, agregarla
    if (this.capturedPhoto && this.selectedFiles.length === 0) {
      // Crear un File object a partir de la foto capturada
      const byteCharacters = atob(this.capturedPhoto.split(',')[1]);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: 'image/jpeg' });
      const file = new File([blob], `foto_${Date.now()}.jpg`, { type: 'image/jpeg' });
      
      this.selectedFiles.push({
        file: file,
        base64: this.capturedPhoto,
        type: 'photo'
      });
    }
    
    this.dialogRef.close(this.selectedFiles);
  }

  close() {
    this.pararVideo();
    this.dialogRef.close();
  }

  private pararVideo() {
    if (this.stream) {
      this.stream
        .getTracks()
        .forEach((track: MediaStreamTrack) => track.stop());
      this.stream = null;
    }
  }

  showPrev() {
    if (this.selectedFiles.length > 0) {
      this.sliderIndex =
        (this.sliderIndex - 1 + this.selectedFiles.length) %
        this.selectedFiles.length;
      this.updateSliderView();
    }
  }

  showNext() {
    if (this.selectedFiles.length > 0) {
      this.sliderIndex = (this.sliderIndex + 1) % this.selectedFiles.length;
      this.updateSliderView();
    }
  }

  updateSliderView() {
    const current = this.selectedFiles[this.sliderIndex];
    if (current) {
      this.capturedPhoto = current.base64;
      this.mode = current.type;
      this.preview = true;
    }
  }

  removeFile(index: number) {
    if (index >= 0 && index < this.selectedFiles.length) {
      this.selectedFiles.splice(index, 1);
      if (this.selectedFiles.length === 0) {
        this.preview = false;
        this.capturedPhoto = null;
        this.sliderIndex = 0;
      } else {
        if (this.sliderIndex >= this.selectedFiles.length) {
          this.sliderIndex = this.selectedFiles.length - 1;
        }
        this.updateSliderView();
      }
    }
  }
}
